import request from '@/CommonDP/utils/request';
// 目录模板维护
export default {
  // 列表
  getTree(enterpriseId) {
    return request.get(
      `/standardCatalog/getTree?enterpriseId=${enterpriseId}`
    );
  },
  // 删除
  deleteTree(templateId) {
    return request.post(
      `/standardCatalog/deleteTree?templateId=${templateId}`
    );
  },
  // 新增 模板
  insertTree(params) {
    return request.post(`/standardCatalog/insertTree`, params);
  },
  // 重命名
  standardRename(params) {
    return request.post(`/standardCatalog/rename`, params);
  },
  // 查询文件夹 详情
  detailFile(id) {
    return request.get(`/standardCatalog/detailFile?id=` + id);
  },
  // 同级降级
  updateType(params) {
    return request.post(`/standardCatalog/updateType`, params);
  },
  // 查询文件夹
  selectFolder(templateID, folderID) {
    return request.get(
      `/standardCatalog/selectFolderLazy?templateID=${templateID}&folderID=${folderID}`
    );
  },
  // 上移 下移
  standardMove(id, moveup, templateID) {
    return request.get(
      `/standardCatalog/move?id=${id}&moveup=${moveup}&templateID=${templateID}`
    );
  },
  // 升级  降级
  upAndDown(folderID, moveType) {
    return request.get(
      `/standardCatalog/upAndDown?folderID=${folderID}&moveType=${moveType}`
    );
  },
  // 删除 右侧
  deleteFile(folderID) {
    return request.get(
      `/standardCatalog/deleteFile?folderID=` + folderID
    );
  },
  // 同级降级
  insertSameLevel(params) {
    return request.post(`/standardCatalog/insertSameLevel`, params);
  },
  // 复制 粘贴
  copyFile(templateID1, templateID2) {
    return request.get(
      `/standardCatalog/copyFile?templateID1=${templateID1}&templateID2=${templateID2}`
    );
  }
};
